<template>
  <v-container fluid pa-0>
    <v-layout
      row
      wrap
      align-center
      class="secondary darken-1"
      justify-space-around
      style="min-height:140px"
    />
    <v-layout row wrap justify-center style="margin-top:-54px">
      <v-card class="flex xs12 sm11 shadow">
        <v-toolbar color="grey6 elevation-0" height="54px">
          <div class="di-flex align-center">
            <v-icon size="24px">mdi-file-document-box-multiple-outline</v-icon>
            <span class="subheading font-weight-bold mt-1 ml-2">
              {{ $t("re_assessment_reports") }}
            </span>
          </div>
          <v-spacer />
        </v-toolbar>

        <v-data-table
          :items="items"
          :loading="loading"
          :headers="headers"
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{ item }">
            <td>{{ item.name }}</td>
            <td>{{ item.last_modified }}</td>
            <td>{{ item.size }}</td>
            <td>
              <v-btn
                flat
                icon
                class="ma-0 pa-0"
                color="grey darken-1"
                v-if="can('view_assessments')"
              >
                <v-icon @click="downloadReport(item)">file_download</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                class="ma-0 pa-0"
                color="grey darken-1 "
                v-if="can('delete_assessments')"
              >
                <v-icon @click="deleteReport(item)">mdi-delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      loading: false,
      btn_loading: false
    };
  },
  computed: {
    headers: vm => [
      {
        value: "name",
        text: vm.$t("file")
      },
      {
        text: vm.$t("date"),
        value: "last_modified"
      },
      {
        value: "size",
        text: vm.$t("size")
      },
      {
        sortable: false,
        value: "actions",
        text: vm.$t("actions")
      }
    ]
  },
  methods: {
    getData() {
      this.loading = true;
      this.axios
        .get(`reports?path=referrals`)
        .then(resp => {
          this.items = resp.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    deleteReport(item) {
      let vm = this;
      this.$alert(`reports/1?type=referrals&&name=${item.name}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    downloadReport(item) {
      this.axios({
        method: "GET",
        url: `download-file?file=${item.file}`,
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", item.name);
        document.body.appendChild(link);
        link.click();
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
